import { useMemo } from "react";
import { useMandatorContext } from "@bn/theming";
import {
  isPortalCodeLogin,
  resolvePortalUrl,
  startPortalCodeLogin,
  USE_INTERNAL_AUTH,
} from "@helpers";

const BASE = import.meta.env.VITE_APP_APP_URL;
const DEFAULT_LOGIN_PATH = "/login";
const DEFAULT_SIGNUP_PATH = "/signup";

const normalize = (p: string) => p.replace(/\/+$/, "") || "/";

const goTo = (url: string, replace: boolean) => {
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};

export function useLoginRoute() {
  const { config } = useMandatorContext();

  return useMemo(() => {
    const isLoginPath = (pathname: string) => {
      const normalizedPath = normalize(pathname);
      return normalizedPath === DEFAULT_LOGIN_PATH;
    };

    const loginUrl = USE_INTERNAL_AUTH
      ? `${BASE}${DEFAULT_LOGIN_PATH}`
      : (resolvePortalUrl(config.links?.login) ??
        `${BASE}${DEFAULT_LOGIN_PATH}`);

    const registrationUrl = USE_INTERNAL_AUTH
      ? `${BASE}${DEFAULT_SIGNUP_PATH}`
      : resolvePortalUrl(config.links?.registration);

    const redirectToLogin = ({
      replace = false,
      returnTo,
    }: { replace?: boolean; returnTo?: string } = {}) => {
      goTo(
        isPortalCodeLogin()
          ? startPortalCodeLogin(loginUrl, returnTo)
          : loginUrl,
        replace
      );
    };

    const redirectToRegistration = ({
      replace = false,
    }: { replace?: boolean } = {}) => {
      if (registrationUrl) {
        goTo(registrationUrl, replace);
      } else {
        redirectToLogin({ replace });
      }
    };

    return {
      redirectToLogin,
      redirectToRegistration,
      isLoginPath,
    };
  }, [config.links]);
}
